"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manual_start = void 0;
var api_1 = require("../../../api");
var manual_start = function (req) {
    return (0, api_1.apiPost)({
        endpoint: "v3/auction/manual_start",
        // data: formData,
        data: req,
    });
};
exports.manual_start = manual_start;
